module.exports = __webpack_public_path__ + "static/media/icon-price-high.dc55e33f.svg";